import StyledTextUpdate from './StyledTextUpdate'

/**
 * PhoneNumberInput - A component for inputting and validating phone numbers
 *
 * This component wraps the StyledTextUpdate component to provide phone number
 * validation functionality. It removes any non-digit characters before passing phone number to the parent component.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.defaultValue - The initial phone number value to display
 * @param {Function} props.onSave - Callback function that receives the validated phone number
 *                                  when validation succeeds. Not called if validation fails.
 *
 * @example
 * // Basic usage
 * <PhoneNumberInput
 *   defaultValue="1234567890"
 *   onSave={(phoneNumber) => savePhoneNumber(phoneNumber)}
 * />
 *
 * @returns {JSX.Element} A styled text input component with phone number validation
 */
const PhoneNumberInput = ({ defaultValue, onSave }) => {
  const validatePhoneNumber = (value) => {
    let phoneNumber = value.replace(/\D/g, '')
    onSave(phoneNumber)
  }

  return <StyledTextUpdate onSave={(value) => validatePhoneNumber(value)} defaultValue={defaultValue} />
}

export default PhoneNumberInput
